import {
  GENERAL_REQUEST_LOADING,

  TOOLS_ACCESS_USER_ACCOUNT_SUCCESS,
  LOGIN_SUCCESS,
  
  EMPLOYER_FIELD_CHANGED,
  EMPLOYER_UPDATE,
  EMPLOYER_UPDATE_SUCCESS,
  EMPLOYER_UPDATE_FAIL,

  AUTH_EMPLOYER,
  AUTH_EMPLOYER_SUCCESS,
  AUTH_EMPLOYER_FAIL,

  EMPLOYER_WELLNESS_SETUP_SUCCESS,
  EMPLOYER_WELLNESS_SETUP_FAIL,


  EMPLOYER_WELLNESS_TERMINATE_SUCCESS,
  EMPLOYER_WELLNESS_TERMINATE_FAIL,

  EMPLOYER_TERMINATE,
  EMPLOYER_TERMINATE_FAIL,

  EMPLOYER_SET_DATA,
  EMPLOYER_SET_ERRORS,

  EMPLOYER_GET_PLAN_DETAILS,
  EMPLOYER_GET_PLAN_DETAILS_SUCCESS,

  EMPLOYER_GET_FUNDING_DETAILS,
  EMPLOYER_GET_FUNDING_DETAILS_SUCCESS,

  EMPLOYER_EMPLOYEE_DIRECTORY,
  EMPLOYER_EMPLOYEE_DIRECTORY_FAIL,
  EMPLOYER_EMPLOYEE_DIRECTORY_SUCCESS,

  AUTH_CLASSIFICATION_DIRECTORY,
  AUTH_CLASSIFICATION_DIRECTORY_SUCCESS,
  AUTH_CLASSIFICATION_DIRECTORY_FAIL,

  EMPLOYER_EMPLOYEE_LIST_SUCCESS,

  AUTH_DIVISION_DIRECTORY,
  EMPLOYER_DIVISION_LIST_SUCCESS,

  EMPLOYER_PENDING_EMPLOYEE_CLASS_CHANGE_SUCCESS,

  EMPLOYER_PENDING_EMPLOYEE_ONE_TIME_CHANGE_SUCCESS,

  EMPLOYER_NON_PLAN_ADMIN_CHANGE_SUCCESS,

  EMPLOYER_GET_BANKING_SUCCESS,
  EMPLOYER_SET_BANKING_SUCCESS,

  EMPLOYEE_TERMINATE_SUCCESS,

  EMPLOYER_NEW_EMPLOYEE_REMOVE,
  EMPLOYER_NEW_EMPLOYEE_REMOVE_SUCCESS,
  EMPLOYER_NEW_EMPLOYEE_ADD,
  EMPLOYER_NEW_EMPLOYEE_ADD_SUCCESS,

  EMPLOYER_EMPLOYEES_ADD_SUCCESS,
  EMPLOYER_EMPLOYEES_ADD_FAIL,

  EMPLOYER_STRIPE_CARD_SUCCESS,
  EMPLOYER_STRIPE_CARD_FAIL,

  EMPLOYER_STRIPE_EMAIL_SUCCESS,
  EMPLOYER_STRIPE_EMAIL_FAIL,

  EMPLOYER_BANKING_IMAGE_ADD,
  EMPLOYER_BANKING_IMAGE_ADD_SUCCESS,
  EMPLOYER_BANKING_IMAGE_ADD_FAILED,
  EMPLOYER_BANKING_IMAGE_RESET,
  
  EMPLOYER_WELLNESS_DIRECTORY_SUCCESS,
  EMPLOYER_WELLNESS_DIRECTORY_FAIL,

  EMPLOYER_WELLNESS_MANAGE_SUCCESS,
  EMPLOYER_WELLNESS_MANAGE_FAIL,

  EMPLOYER_ENABLE_ONLINE_FAIL,

  EMPLOYER_REFUND_BALANCE_FAIL,

  EMPLOYER_INSURANCE_FUNDING_FAIL,

  ERROR_CLEAR,
  LOGOUT,
} from '../actions/types';

const INITIAL_STATE = {
  employer: [],

  employeeDirectory: {},
  classChanges: [],
  oneTimeChanges: [],
  nonPlanAdmins: [],
  divisions: [],

  savedNewEmployees: [],
  pendingEmployees: {},
  chequeImage: '',
  wellness_limits: [],
  pending_wellness_limits: [],
  wellness_categories: [],
  active_wellness_categories:[],
  stripeCard: null,
  stripEmail: null,

  error: false,
  errors: { },
  message: '',
  loading: false,
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case TOOLS_ACCESS_USER_ACCOUNT_SUCCESS:
        return {
          ...INITIAL_STATE,
          error: false,
          errors: {},
          loading: false,
          employer: action.data.employer,
          businessBanking: action.data.businessBanking,
          active_wellness_categories: action.data.employer.WELLNESS_CATEGORIES
        };
      case LOGIN_SUCCESS:
        return {
          ...INITIAL_STATE,
          error: false,
          errors: {},
          loading: false,
          employer: action.data.employer,
          businessBanking: action.data.businessBanking,
          active_wellness_categories: action.data.employer.WELLNESS_CATEGORIES
        };

      case EMPLOYER_FIELD_CHANGED:
        return { ...state,
          employer: {
            ...state.employer,
            [action.fieldName]: action.fieldValue
          }
        };
      case EMPLOYER_SET_DATA:
        return (action.datagroup !== '')?
        { ...state, [action.datagroup]: {...state[action.datagroup], [action.dataname]: action.datavalue }, error: false, errors: {}, loading: false }
        :
        { ...state, [action.dataname]: action.datavalue, error: false, loading: false };
      case EMPLOYER_SET_ERRORS:
        return { ...state, error: action.error, errors: action.errors, loading: false };
      case EMPLOYER_GET_PLAN_DETAILS:
        return { ...state, error: false, errors: {}, loading: true };
      case EMPLOYER_GET_PLAN_DETAILS_SUCCESS:
        return { ...state, employer: {...state.employer, ...action.data.employer}, error: false, errors: {}, loading: false };
      case EMPLOYER_GET_FUNDING_DETAILS:
        return { ...state, error: false, errors: {}, loading: true };
      case EMPLOYER_GET_FUNDING_DETAILS_SUCCESS:
        return { ...state,
                    employer: {...state.employer, ...action.data.employer},
                    message: action.message,
                    error: false, errors: {}, loading: false };
      case AUTH_EMPLOYER:
        return { ...state, error: false, errors: {}, loading: true, success: false, message: '' };
      case AUTH_EMPLOYER_SUCCESS:
        return { ...state, employer: action.employer, error: false, errors: {}, loading: false };
      case AUTH_EMPLOYER_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false };
      case EMPLOYER_UPDATE:
        return { ...state, error: false, errors: {}, loading: true, success: false, message: '' };
      case EMPLOYER_UPDATE_SUCCESS:
        return {
          ...state,
          error: false,
          employer: {...state.employer, ...action.employer},
          errors: {},
          loading: false,
          success: true,
          message: action.message
        };
      case EMPLOYER_UPDATE_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
      case EMPLOYER_EMPLOYEE_DIRECTORY:
        return { ...state, error: false, errors: {}, loading: true, success: false, message: '' };
      case AUTH_DIVISION_DIRECTORY:
        return { ...state, error: false, errors: {}, loading: true, success: false, message: '' };
      case AUTH_CLASSIFICATION_DIRECTORY:
        return { ...state, error: false, errors: {}, loading: true, success: false, message: '' };
      case EMPLOYER_EMPLOYEE_DIRECTORY_SUCCESS:
        return {
          ...state,
          error: false,
          employeeDirectory: action.data.directory,
          classChanges: action.data.classChanges,
          oneTimeChanges: action.data.oneTimeChanges,
          nonPlanAdmins: action.data.nonPlanAdmins,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        };
      case EMPLOYER_EMPLOYEE_DIRECTORY_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };

      case EMPLOYER_WELLNESS_DIRECTORY_SUCCESS:
        return { 
          ...state,
          error: false,
          wellness_limits: action.data.wellness_limits,
          pending_wellness_limits: action.data.pending_wellness_limits,
          wellness_categories: action.data.wellness_categories,
          active_wellness_categories: action.data.active_wellness_categories,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        };
      case EMPLOYER_WELLNESS_DIRECTORY_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };

      case EMPLOYER_ENABLE_ONLINE_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
        
      case EMPLOYER_WELLNESS_MANAGE_SUCCESS:
        return { 
          ...state,
          error: false,
          wellness_limits: action.data.wellness_limits,
          pending_wellness_limits: action.data.pending_wellness_limits,
          wellness_categories: action.data.wellness_categories,
          active_wellness_categories: action.data.active_wellness_categories,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        };
      case EMPLOYER_WELLNESS_MANAGE_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
      case EMPLOYER_WELLNESS_SETUP_SUCCESS:
        return { ...state, employer: action.data.employer, error: false, errors: {}, loading: false, success: false, message: '' };
      case EMPLOYER_WELLNESS_TERMINATE_SUCCESS:
        return { ...state, employer: action.data.employer, error: false, errors: {}, loading: false, success: false, message: '' };
      case EMPLOYER_WELLNESS_SETUP_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
      case EMPLOYER_WELLNESS_TERMINATE_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
      case AUTH_CLASSIFICATION_DIRECTORY_SUCCESS:
        return {
          ...state,
          error: false,
          classifications: action.data.classifications,
          pendingClassifications: action.data.pendingClassifications,
          errors: {},
          loading: false,
          success: true,
          message: action.message
        };
      case EMPLOYER_EMPLOYEE_LIST_SUCCESS:
        return {
          ...state,
          error: false,
          employeeDirectory: action.data.directory,
          nonPlanAdmins: (action.data.nonPlanAdmins)? action.data.nonPlanAdmins : state.nonPlanAdmins,
          divisions: (action.data.divisions)? action.data.divisions : state.divisions,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        };
      case EMPLOYER_DIVISION_LIST_SUCCESS:
        return {
          ...state,
          error: false,
          divisions: action.data.directory,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        };
      case EMPLOYEE_TERMINATE_SUCCESS:
        return {
          ...state,
          error: false,
          employeeDirectory: action.data.directory,
          nonPlanAdmins: action.data.nonPlanAdmins,
          classifications: (action.data.classifications)? action.data.classifications : state.classifications,
          divisions: (action.data.divisions)? action.data.divisions : state.divisions,
          classChanges: (action.data.classChanges)? action.data.classChanges: state.classChanges,
          oneTimeChanges: (action.data.oneTimeChanges)? action.data.oneTimeChanges: state.oneTimeChanges,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        };
      case EMPLOYER_PENDING_EMPLOYEE_CLASS_CHANGE_SUCCESS:
        return {
          ...state,
          error: false,
          employeeDirectory: (action.data.directory)? action.data.directory : state.employeeDirectory,
          classifications: (action.data.classifications)? action.data.classifications : state.classifications,
          classChanges: action.data.classChanges,
          errors: {},
          loading: false,
          success: true,
          message: action.message
        };
      case EMPLOYER_PENDING_EMPLOYEE_ONE_TIME_CHANGE_SUCCESS:
        return {
          ...state,
          error: false,
          oneTimeChanges: action.data.oneTimeChanges,
          errors: {},
          loading: false,
          success: true,
          message: action.message
        };
      case EMPLOYER_NON_PLAN_ADMIN_CHANGE_SUCCESS:
        return {
          ...state,
          error: false,
          nonPlanAdmins: action.data.nonPlanAdmins,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        };
      case EMPLOYER_BANKING_IMAGE_ADD:
        return {
          ...state,
          error: false,
          errors: {},
          loading: true
        };
      case EMPLOYER_BANKING_IMAGE_ADD_SUCCESS:
        return {
          ...state,
          chequeImage: action.data,
          error: false,
          errors: {},
          loading: false
        };
      case EMPLOYER_BANKING_IMAGE_ADD_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case EMPLOYER_BANKING_IMAGE_RESET:
        return {
          ...state,
          chequeImage: INITIAL_STATE.chequeImage,
          error: false,
          errors: {},
          loading: false
        };
      case EMPLOYER_GET_BANKING_SUCCESS:
        return {
          ...state,
          error: false,
          businessBanking: action.data.businessBanking,
          chequeImage: INITIAL_STATE.chequeImage,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        }
      case EMPLOYER_SET_BANKING_SUCCESS:
        return {
          ...state,
          error: false,
          businessBanking: action.data.businessBanking,
          chequeImage: INITIAL_STATE.chequeImage,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        }
      case AUTH_CLASSIFICATION_DIRECTORY_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
      case EMPLOYER_TERMINATE:
        return { ...state, error: false, errors: {}, loading: true, success: false, message: '' };
      case EMPLOYER_TERMINATE_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
      case EMPLOYER_NEW_EMPLOYEE_ADD:
        return {
          ...state,
          savedNewEmployees: [...state.savedNewEmployees, action.newEmployee],
          error: false,
          errors: {},
          loading: true
        };
      case EMPLOYER_NEW_EMPLOYEE_REMOVE:
        return {
          ...state,
          savedNewEmployees: state.savedNewEmployees.filter((item) => item !== action.newEmployee),
          error: false,
          errors: {},
          loading: true
        };
      case EMPLOYER_NEW_EMPLOYEE_ADD_SUCCESS:
        return {
          ...state,
          error: false,
          errors: {},
          loading: false
        };
      case EMPLOYER_NEW_EMPLOYEE_REMOVE_SUCCESS:
        return {
          ...state,
          error: false,
          errors: {},
          loading: false
        };
      case EMPLOYER_EMPLOYEES_ADD_SUCCESS:
        return {
          ...state,
          error: false,
          employeeDirectory: action.data.directory,
          classifications: (action.data.classifications)? action.data.classifications : state.classifications,
          recentNewEmployees: (action.data.recentNewEmployees)? action.data.recentNewEmployees : [],
          savedNewEmployees: [],
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        };
      case EMPLOYER_EMPLOYEES_ADD_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
      case EMPLOYER_STRIPE_CARD_SUCCESS:
        return {
          ...state,
          error: false,
          stripeCard: action.data.stripeCard,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        };
      case EMPLOYER_STRIPE_CARD_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
      case EMPLOYER_STRIPE_EMAIL_SUCCESS:
        return {
          ...state,
          error: false,
          stripeEmail: action.data.stripeEmail,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        };
      case EMPLOYER_STRIPE_EMAIL_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
     case EMPLOYER_REFUND_BALANCE_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
      case EMPLOYER_INSURANCE_FUNDING_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
      case GENERAL_REQUEST_LOADING:
        return { ...state, error: false, errors: {}};
      case ERROR_CLEAR:
        return { ...state, error: false, errors: {}, loading: false };
      case LOGOUT:
        return INITIAL_STATE;
      default:
        return state;
    }
};

export default reducer;
